exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".venue__description {\n  font-size: 13px;\n  text-align: center;\n  max-width: 360px;\n  margin: 10px auto; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./node_modules/sass-resources-loader/lib/loader.js??ref--1-oneOf-3-3!./src/components/Authentication/CreateVenueForm/index.scss
// module id = 1031
// module chunks = 1